import { render, staticRenderFns } from "./FormInsert.vue?vue&type=template&id=2b1a5f6c"
import script from "./FormInsert.vue?vue&type=script&lang=js"
export * from "./FormInsert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports